/**
 * Quilt Page Animations
 * Handles data-animation-* attributes using GSAP and ScrollTrigger
 */
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.warn("GSAP or ScrollTrigger not found for Quilt animations.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // 1. Handle data-animation-trigger (Smooth Load / Fade-in)
  document.querySelectorAll("[data-animation-trigger]").forEach((trigger) => {
    const animationName = trigger.getAttribute("data-animation-trigger");
    const animatedElements =
      animationName === "self"
        ? [trigger]
        : trigger.querySelectorAll(`[data-animation-names="${animationName}"]`);

    animatedElements.forEach((el) => {
      // Get animation parameters
      const fromsAttr = el.getAttribute("data-animation-froms");
      const tosAttr = el.getAttribute("data-animation-tos");
      const propsAttr = el.getAttribute("data-animation-properties");

      if (!fromsAttr || !tosAttr || !propsAttr) return;

      const froms = fromsAttr.split(",").map((s) => s.trim());
      const tos = tosAttr.split(",").map((s) => s.trim());
      const props = propsAttr.split(",").map((s) => s.trim());

      const duration =
        parseInt(el.getAttribute("data-animation-durations")) / 1000 || 0.7;
      const delay =
        parseInt(el.getAttribute("data-animation-delays")) / 1000 || 0;
      const easing = el.getAttribute("data-animation-easings") || "power2.out";

      // Map easing names (Onebed uses custom names sometimes)
      const gsapEase = easing === "outExpo" ? "expo.out" : easing;

      let fromVars = {};
      let toVars = {};

      props.forEach((prop, i) => {
        const fromVal = froms[i];
        const toVal = tos[i];

        // Map common translation properties
        const p =
          prop === "translateY" ? "y" : prop === "translateX" ? "x" : prop;

        // Handle px and numbers
        const getVal = (v) => {
          if (!v) return 0;
          if (typeof v === "string" && v.includes("px")) return parseFloat(v);
          if (isNaN(v)) return v;
          return parseFloat(v);
        };

        fromVars[p] = getVal(fromVal);
        toVars[p] = getVal(toVal);
      });

      // Special case: Initial opacity should be 0 if we are animating it
      if (toVars.opacity !== undefined) {
        gsap.set(el, { opacity: fromVars.opacity || 0 });
      }

      gsap.fromTo(el, fromVars, {
        ...toVars,
        duration: duration,
        delay: delay,
        ease: gsapEase,
        scrollTrigger: {
          trigger: trigger,
          start: "top 85%", // Trigger slightly before it comes into view
          toggleActions: "play none none none",
          once: true,
        },
      });
    });
  });

  // 2. Handle Video Trigger (Play on scroll)
  document.querySelectorAll(".Quilt__VideoTrigger").forEach((videoTrigger) => {
    const video = videoTrigger.querySelector("video");
    if (video) {
      ScrollTrigger.create({
        trigger: videoTrigger,
        start: "top 80%",
        onEnter: () => {
          video.play().catch((err) => {
            console.warn("Video play failed:", err);
          });
        },
        once: true,
      });
    }
  });
});
